/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputMissionVideo
 */
export interface InputMissionVideo {
    /**
     * 
     * @type {string}
     * @memberof InputMissionVideo
     */
    video?: string;
}

/**
 * Check if a given object implements the InputMissionVideo interface.
 */
export function instanceOfInputMissionVideo(value: object): boolean {
    return true;
}

export function InputMissionVideoFromJSON(json: any): InputMissionVideo {
    return InputMissionVideoFromJSONTyped(json, false);
}

export function InputMissionVideoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputMissionVideo {
    if (json == null) {
        return json;
    }
    return {
        
        'video': json['video'] == null ? undefined : json['video'],
    };
}

export function InputMissionVideoToJSON(value?: InputMissionVideo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'video': value['video'],
    };
}

